export default {
  methods: {
    async submitAction(data) {
      return data
    }
  }
}
